// import ModalComponent from '@components/common/Modal';
// import { message } from 'antd';
// import {
//   DownloadOutlined,
//   LeftOutlined,
//   PauseCircleOutlined,
//   PlayCircleOutlined,
//   RightOutlined,
//   RotateLeftOutlined,
//   RotateRightOutlined,
//   UndoOutlined,
//   ZoomInOutlined,
//   ZoomOutOutlined
// } from '@ant-design/icons';
// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
// import JSZip from 'jszip';
// import saveAs from 'file-saver';
// import Helpers from 'helpers/Helpers';

// interface IImageItem {
//   url: string;
//   name?: string;
// }

// interface IOMConfig {
//   isOpen: boolean;
//   base64?: string;
//   callBackClose?: () => any;
//   callBackRefresh?: () => any;
//   callBackCreate?: (data: any) => any;
//   listHinhNew?: any;
//   data?: any;
//   status?: any;
//   listHinh?: any;
//   images1?: any;
//   // Vị trí ảnh đang xem trong listHinh — truyền tường minh từ nơi gọi (vd click đúng ảnh nào trong 1
//   // danh sách nhiều ảnh) để tránh phải dò khớp lại theo url, dễ sai khi trùng/khác định dạng chuỗi.
//   initialIndex?: number;
//   //   dataAccountant: ISelectOption[];
// }

// const SLIDESHOW_INTERVAL_MS = 2500;
// const VIEWER_HEIGHT = 500;

// const overlayBtnClass =
//   'w-7 h-7 rounded-md bg-white hover:bg-gray-100 text-gray-700 shadow flex items-center justify-center transition-colors';

// export default function ModalViewImages(props: IOMConfig) {
//   const { t } = useTranslation();
//   const imageRef = useRef<any>(null);
//   const [isSaving, setIsSaving] = useState<boolean>(false);
//   const [isSavingAll, setIsSavingAll] = useState<boolean>(false);
//   const [rotation, setRotation] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);

//   // Danh sách ảnh để chuyển nhanh qua thumbnail — ưu tiên lấy từ listHinh (nhiều ảnh); nếu không có
//   // (chỉ xem 1 ảnh đơn lẻ) thì fallback về đúng ảnh đang xem (base64/images1).
//   const images: IImageItem[] = useMemo(() => {
//     const list = (props.listHinh || [])
//       .filter((item: any) => item?.url)
//       .map((item: any) => ({ url: item.url as string, name: item.name || item.uid }));
//     if (list.length > 0) return list;
//     const url = props.base64 || props.images1?.url;
//     return url ? [{ url, name: props.images1?.name }] : [];
//   }, [props.listHinh, props.base64, props.images1]);

//   const [activeIndex, setActiveIndex] = useState<number>(() => {
//     if (props.initialIndex != null && props.initialIndex >= 0) return props.initialIndex;
//     const url = props.base64 || props.images1?.url;
//     const idx = images.findIndex(img => img.url === url);
//     return idx >= 0 ? idx : 0;
//   });

//   const activeImage = images[activeIndex];
//   const hasMultiple = images.length > 1;

//   const rotateClockwise = useCallback(() => {
//     setRotation(rotation => (rotation + 90) % 360);
//   }, []);

//   const rotateAnticlockwise = useCallback(() => {
//     setRotation(rotation => (rotation - 90) % 360);
//   }, []);

//   const goToImage = useCallback((idx: number) => {
//     setIsPlaying(false);
//     setActiveIndex(idx);
//   }, []);

//   const goPrev = useCallback(() => {
//     setIsPlaying(false);
//     setActiveIndex(prev => (prev - 1 + images.length) % images.length);
//   }, [images.length]);

//   const goNext = useCallback(() => {
//     setIsPlaying(false);
//     setActiveIndex(prev => (prev + 1) % images.length);
//   }, [images.length]);

//   // Thanh công cụ dạng icon, đè lên góc dưới trái khung ảnh — cần nằm trong TransformWrapper để lấy
//   // được zoomIn/zoomOut/resetTransform từ useControls().
//   const Controls = () => {
//     const { zoomIn, zoomOut, resetTransform } = useControls();

//     return (
//       <div className="absolute left-2 bottom-2 z-10 flex items-center gap-1.5 bg-black/40 rounded-full px-2 py-1.5">
//         {hasMultiple && (
//           <button
//             type="button"
//             title={
//               isPlaying
//                 ? t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Pause')
//                 : t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Play')
//             }
//             className={overlayBtnClass}
//             onClick={() => setIsPlaying(p => !p)}
//           >
//             {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
//           </button>
//         )}
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ZoomIn')}
//           className={overlayBtnClass}
//           onClick={() => zoomIn()}
//         >
//           <ZoomInOutlined />
//         </button>
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ZoomOut')}
//           className={overlayBtnClass}
//           onClick={() => zoomOut()}
//         >
//           <ZoomOutOutlined />
//         </button>
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Reset')}
//           className={overlayBtnClass}
//           onClick={() => resetTransform()}
//         >
//           <UndoOutlined />
//         </button>
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.RotateLeft')}
//           className={overlayBtnClass}
//           onClick={() => rotateAnticlockwise()}
//         >
//           <RotateLeftOutlined />
//         </button>
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.RotateRight')}
//           className={overlayBtnClass}
//           onClick={() => rotateClockwise()}
//         >
//           <RotateRightOutlined />
//         </button>
//         <button
//           type="button"
//           title={t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.SaveToDevice')}
//           className={overlayBtnClass}
//           onClick={() => handleDownloadImage()}
//         >
//           <DownloadOutlined />
//         </button>
//       </div>
//     );
//   };

//   // Đổi ảnh đang xem -> reset góc xoay + tạo lại Image() offscreen (dùng crossOrigin để canvas export
//   // không bị lỗi tainted) trỏ đúng ảnh mới, phục vụ nút tải về.
//   useEffect(() => {
//     if (!activeImage?.url) return;
//     setRotation(0);
//     imageRef.current = new Image();
//     imageRef.current.src = `${activeImage.url}?crossorigin`; // thêm vào để src tránh bắt cors server
//     imageRef.current.setAttribute('crossOrigin', 'anonymous'); // sử dụng tránh cors

//     return () => {
//       imageRef.current = null; // xoá sau khi rời trang
//     };
//   }, [activeImage?.url]);

//   // Chế độ tự động chuyển ảnh (slideshow) — chỉ chạy khi có nhiều hơn 1 ảnh, dừng ngay khi tắt/đóng modal
//   useEffect(() => {
//     if (!isPlaying || !hasMultiple) return;
//     const timer = setInterval(() => {
//       setActiveIndex(prev => (prev + 1) % images.length);
//     }, SLIDESHOW_INTERVAL_MS);
//     return () => clearInterval(timer);
//   }, [isPlaying, hasMultiple, images.length]);

//   const handleDownloadImage = async () => {
//     try {
//       setIsSaving(true);
//       if (!imageRef.current?.width) {
//         message.error(t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ErrorSaveImg'));
//         setIsSaving(false);
//         return;
//       }
//       const canvas: any = document.getElementById('idcanvas');
//       const ctx = canvas.getContext('2d');

//       const widthImg = imageRef.current.width;
//       const heightImg = imageRef.current.height;
//       canvas.width = widthImg; // set kích thước ảnh canvas
//       canvas.height = heightImg; // set kích thước ảnh canvas
//       await ctx.drawImage(imageRef.current, 0, 0, widthImg, heightImg, 0, 0, widthImg, heightImg);
//       // draw ảnh vào canvas (img, sx (vị trí cắt trên ảnh gốc),  (vị trí cắt trên ảnh gốc), sWidth (kích thước sẽ lấy), sHeight (kích thước sẽ lấy), dx (vị trí đặt trên canvas), dy (vị trí đặt trên canvas), dWidth(kích thuốc ảnh trên canvas), dHeight(kích thuốc ảnh trên canvas) )

//       const a = document.createElement('a');
//       a.download =
//         activeImage?.name || 'aom1_download_' + Helpers.ConvertDateToISOString(new Date()).slice(0, -1) + '.png';
//       document.body.appendChild(a);
//       a.href = canvas.toDataURL('image/png'); // convert canvas to url png
//       a.click();
//       document.body.removeChild(a);

//       // chiều cao ảnh dạng px tương ứng với độ delay tắt loading status
//       setTimeout(() => {
//         setIsSaving(false);
//       }, heightImg);
//     } catch (error) {
//       console.log('err load img', error);
//       message.error(t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ErrorSaveImg'));
//       setIsSaving(false);
//     }
//   };

//   // Tải toàn bộ ảnh trong danh sách -> gộp thành 1 file .zip (thay vì tải rời từng file, dễ bị trình
//   // duyệt chặn tải hàng loạt và lộn xộn thư mục tải về của người dùng).
//   const handleDownloadAll = async () => {
//     if (images.length === 0) return;
//     setIsSavingAll(true);
//     let hasError = false;
//     try {
//       const zip = new JSZip();
//       const usedNames = new Set<string>();
//       let addedCount = 0;

//       for (let i = 0; i < images.length; i++) {
//         const img = images[i];
//         try {
//           const res = await fetch(`${img.url}?crossorigin`, { method: 'GET' });
//           if (!res.ok) throw new Error(`HTTP ${res.status}`);
//           const blob = await res.blob();

//           let fileName = img.name || `anh_${i + 1}.png`;
//           if (usedNames.has(fileName)) {
//             const dotIdx = fileName.lastIndexOf('.');
//             const base = dotIdx > -1 ? fileName.slice(0, dotIdx) : fileName;
//             const ext = dotIdx > -1 ? fileName.slice(dotIdx) : '';
//             fileName = `${base}_${i + 1}${ext}`;
//           }
//           usedNames.add(fileName);
//           zip.file(fileName, blob);
//           addedCount++;
//         } catch (err) {
//           hasError = true;
//           console.log('Lỗi tải 1 file trong danh sách tải tất cả:', img.url, err);
//         }
//       }

//       if (addedCount > 0) {
//         const zipBlob = await zip.generateAsync({ type: 'blob' });
//         saveAs(zipBlob, `anh_${Helpers.ConvertDateToISOString(new Date()).slice(0, -1)}.zip`);
//       }
//       if (hasError) message.error(t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ErrorSaveAllImg'));
//     } catch (error) {
//       message.error(t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.ErrorSaveAllImg'));
//     } finally {
//       setIsSavingAll(false);
//     }
//   };

//   return (
//     <ModalComponent
//       modalTitle={t('Administrator.UploadImage.Title')}
//       modalSize="medium"
//       visible={props.isOpen}
//       hiddenFooter
//       onCancel={props.callBackClose}
//       className="z-50"
//     >
//       <div>
//         <canvas id="idcanvas" className="hidden"></canvas>

//         <div className="px-4 pb-2 flex flex-col gap-2">
//           {/* Khung ảnh chính — nền tối, mũi tên chuyển ảnh 2 bên, toolbar icon đè góc dưới trái, số
//               thứ tự đè góc dưới phải (giống UI thư viện ảnh camera xe) */}
//           <div className="relative bg-black rounded-md overflow-hidden" style={{ height: VIEWER_HEIGHT }}>
//             {activeImage && (
//               <TransformWrapper key={activeImage.url} wheel={{ smoothStep: 0.003 }}>
//                 {() => (
//                   <>
//                     <TransformComponent
//                       wrapperStyle={{ width: '100%', height: '100%' }}
//                       contentStyle={{
//                         width: '100%',
//                         height: '100%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                       }}
//                     >
//                       <img
//                         id="view-one-image"
//                         src={activeImage.url}
//                         style={{ transform: `rotate(${rotation}deg)`, maxHeight: VIEWER_HEIGHT - 40 }}
//                         className="max-w-full object-contain"
//                         alt=""
//                       />
//                     </TransformComponent>
//                     <Controls />
//                   </>
//                 )}
//               </TransformWrapper>
//             )}

//             {hasMultiple && (
//               <>
//                 <button
//                   type="button"
//                   onClick={goPrev}
//                   className={`absolute left-2 top-1/2 -translate-y-1/2 z-10 ${overlayBtnClass}`}
//                 >
//                   <LeftOutlined />
//                 </button>
//                 <button
//                   type="button"
//                   onClick={goNext}
//                   className={`absolute right-2 top-1/2 -translate-y-1/2 z-10 ${overlayBtnClass}`}
//                 >
//                   <RightOutlined />
//                 </button>
//                 <div className="absolute right-2 bottom-2 z-10 bg-black/45 text-white text-xs px-2 py-1 rounded-full">
//                   {activeIndex + 1}/{images.length}
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Dải thumbnail bên dưới — bấm để chuyển nhanh, ảnh đang xem viền xanh */}
//           {hasMultiple && (
//             <div className="flex gap-2 overflow-x-auto pb-1">
//               {images.map((img, idx) => (
//                 <button
//                   key={img.url + idx}
//                   type="button"
//                   onClick={() => goToImage(idx)}
//                   className={`shrink-0 w-[104px] rounded-md border-2 overflow-hidden text-left transition-colors ${
//                     idx === activeIndex ? 'border-blue-500' : 'border-transparent hover:border-blue-300'
//                   }`}
//                 >
//                   <img src={img.url} alt="" className="w-full h-[68px] object-cover bg-gray-100" />
//                   <div className="px-1 py-0.5 bg-white text-[11px] text-gray-600 truncate">
//                     {img.name || `#${idx + 1}`}
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}

//           <div className="flex space-x-2 justify-end">
//             <div className="select-none rounded px-1 hover:bg-gray-500 bg-gray-400">
//               <a className="text-white" href={activeImage?.url} target="_blank" rel="noreferrer">
//                 {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.OpenInNewTab')}
//               </a>
//             </div>
//             {hasMultiple && (
//               <div className="select-none px-1 rounded hover:bg-green-600 bg-green-500">
//                 <button className="text-white" disabled={isSavingAll} onClick={handleDownloadAll}>
//                   {isSavingAll
//                     ? t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Saveing')
//                     : t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.DownloadAll')}
//                 </button>
//               </div>
//             )}
//             <div className="select-none px-1 rounded hover:bg-blue-500 bg-blue-400">
//               <button className="text-white" onClick={() => handleDownloadImage()}>
//                 {isSaving
//                   ? t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.Saveing')
//                   : t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg.SaveToDevice')}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </ModalComponent>
//   );
// }

import ModalComponent from '@components/common/Modal';
import { message } from 'antd';
import {
  DownloadOutlined,
  LeftOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  RightOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined
} from '@ant-design/icons';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
import JSZip from 'jszip';
import saveAs from 'file-saver';
import Helpers from 'helpers/Helpers';

interface IImageItem {
  url: string;
  name?: string;
}

interface IOMConfig {
  isOpen: boolean;
  base64?: string;
  callBackClose?: () => any;
  callBackRefresh?: () => any;
  callBackCreate?: (data: any) => any;
  listHinhNew?: any;
  data?: any;
  status?: any;
  listHinh?: any;
  images1?: any;
  // Vị trí ảnh đang xem trong listHinh — truyền tường minh từ nơi gọi (vd click đúng ảnh nào trong 1
  // danh sách nhiều ảnh) để tránh phải dò khớp lại theo url, dễ sai khi trùng/khác định dạng chuỗi.
  initialIndex?: number;
}

// ============================================================================
// Hằng số / helper thuần
// ============================================================================
const SLIDESHOW_INTERVAL_MS = 2500;
const VIEWER_HEIGHT = 500;
const VIEWER_PADDING = 40; // chừa chỗ cho toolbar / lề trong khung
const IMAGE_MAX_HEIGHT = VIEWER_HEIGHT - VIEWER_PADDING;
const I18N_PREFIX = 'OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ViewImg';

const overlayBtnClass =
  'w-7 h-7 rounded-md bg-white hover:bg-gray-100 text-gray-700 shadow flex items-center justify-center transition-colors';

const nowStamp = () => Helpers.ConvertDateToISOString(new Date()).slice(0, -1);

// Trùng tên file trong zip thì thêm _<số thứ tự> trước phần mở rộng
const getUniqueFileName = (name: string, index: number, used: Set<string>) => {
  let fileName = name;
  if (used.has(fileName)) {
    const dotIdx = fileName.lastIndexOf('.');
    const base = dotIdx > -1 ? fileName.slice(0, dotIdx) : fileName;
    const ext = dotIdx > -1 ? fileName.slice(dotIdx) : '';
    fileName = `${base}_${index + 1}${ext}`;
  }
  used.add(fileName);
  return fileName;
};

// ============================================================================
// Thành phần con (đặt ngoài component chính để không bị tạo lại mỗi lần render)
// ============================================================================
interface IOverlayButtonProps {
  title?: string;
  onClick: () => void;
  className?: string;
  children: React.ReactNode;
}

const OverlayButton = ({ title, onClick, className = '', children }: IOverlayButtonProps) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    className={`${overlayBtnClass} ${className}`}
    onClick={onClick}
  >
    {children}
  </button>
);

interface IViewerControlsProps {
  tv: (key: string) => string;
  hasMultiple: boolean;
  isPlaying: boolean;
  onTogglePlay: () => void;
  onRotateLeft: () => void;
  onRotateRight: () => void;
  onDownload: () => void;
}

// Thanh công cụ dạng icon, đè lên góc dưới trái khung ảnh — phải nằm trong TransformWrapper để lấy
// được zoomIn/zoomOut/resetTransform từ useControls().
const ViewerControls = ({
  tv,
  hasMultiple,
  isPlaying,
  onTogglePlay,
  onRotateLeft,
  onRotateRight,
  onDownload
}: IViewerControlsProps) => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="absolute left-2 bottom-2 z-10 flex items-center gap-1.5 bg-black/40 rounded-full px-2 py-1.5">
      {hasMultiple && (
        <OverlayButton title={tv(isPlaying ? 'Pause' : 'Play')} onClick={onTogglePlay}>
          {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
        </OverlayButton>
      )}
      <OverlayButton title={tv('ZoomIn')} onClick={() => zoomIn()}>
        <ZoomInOutlined />
      </OverlayButton>
      <OverlayButton title={tv('ZoomOut')} onClick={() => zoomOut()}>
        <ZoomOutOutlined />
      </OverlayButton>
      <OverlayButton title={tv('Reset')} onClick={() => resetTransform()}>
        <UndoOutlined />
      </OverlayButton>
      {/* Xoay xong thì reset vị trí/zoom để ảnh luôn về trạng thái vừa khung, không bị lệch */}
      <OverlayButton
        title={tv('RotateLeft')}
        onClick={() => {
          onRotateLeft();
          resetTransform();
        }}
      >
        <RotateLeftOutlined />
      </OverlayButton>
      <OverlayButton
        title={tv('RotateRight')}
        onClick={() => {
          onRotateRight();
          resetTransform();
        }}
      >
        <RotateRightOutlined />
      </OverlayButton>
      <OverlayButton title={tv('SaveToDevice')} onClick={onDownload}>
        <DownloadOutlined />
      </OverlayButton>
    </div>
  );
};

// ============================================================================
// Component chính
// ============================================================================
export default function ModalViewImages(props: IOMConfig) {
  const { t } = useTranslation();
  const tv = useCallback((key: string) => t(`${I18N_PREFIX}.${key}`), [t]);

  const imageRef = useRef<HTMLImageElement | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingAll, setIsSavingAll] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [naturalSize, setNaturalSize] = useState<{ w: number; h: number } | null>(null);

  // Đo chiều rộng thật của khung ảnh (callback ref nên vẫn đo được khi modal mount muộn, và tự đo lại khi đổi cỡ)
  const [viewerWidth, setViewerWidth] = useState(0);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);
  const setViewerNode = useCallback((node: HTMLDivElement | null) => {
    resizeObserverRef.current?.disconnect();
    resizeObserverRef.current = null;
    if (!node) return;
    setViewerWidth(node.clientWidth);
    resizeObserverRef.current = new ResizeObserver(entries => setViewerWidth(Math.round(entries[0].contentRect.width)));
    resizeObserverRef.current.observe(node);
  }, []);

  // Danh sách ảnh để chuyển nhanh qua thumbnail — ưu tiên lấy từ listHinh (nhiều ảnh); nếu không có
  // (chỉ xem 1 ảnh đơn lẻ) thì fallback về đúng ảnh đang xem (base64/images1).
  const images: IImageItem[] = useMemo(() => {
    const list = (props.listHinh || [])
      .filter((item: any) => item?.url)
      .map((item: any) => ({ url: item.url as string, name: item.name || item.uid }));
    if (list.length > 0) return list;
    const url = props.base64 || props.images1?.url;
    return url ? [{ url, name: props.images1?.name }] : [];
  }, [props.listHinh, props.base64, props.images1]);

  const [activeIndex, setActiveIndex] = useState<number>(() => {
    if (props.initialIndex != null && props.initialIndex >= 0) return props.initialIndex;
    const url = props.base64 || props.images1?.url;
    const idx = images.findIndex(img => img.url === url);
    return idx >= 0 ? idx : 0;
  });

  const activeImage = images[activeIndex];
  const hasMultiple = images.length > 1;

  // Ảnh đang xoay 90°/270°: CSS rotate không đổi kích thước layout, nhưng chiều rộng layout trở thành chiều cao hiển thị
  // và ngược lại -> phải hoán đổi giới hạn rộng/cao để ảnh (dọc hay ngang) luôn vừa khung ở cả 4 hướng xoay.
  // Cách làm: tự tính kích thước vừa khung dựa trên kích thước gốc của ảnh + góc xoay, rồi bọc ảnh trong 1 "hộp"
  // có đúng kích thước SAU khi xoay. Ảnh được đặt tuyệt đối giữa hộp và xoay quanh tâm -> hộp layout luôn khớp với
  // hình hiển thị, không còn bị lệch/tràn như khi chỉ xoay CSS trên ảnh.
  const isSideways = Math.abs(rotation) % 180 === 90;
  const availWidth = viewerWidth > 0 ? viewerWidth - VIEWER_PADDING : 0;
  const fitted = useMemo(() => {
    if (!naturalSize || availWidth <= 0) return null;
    const visW0 = isSideways ? naturalSize.h : naturalSize.w; // kích thước hiển thị gốc sau khi xoay
    const visH0 = isSideways ? naturalSize.w : naturalSize.h;
    const scale = Math.min(availWidth / visW0, IMAGE_MAX_HEIGHT / visH0, 1); // chỉ thu nhỏ, không phóng to
    return {
      imgW: naturalSize.w * scale,
      imgH: naturalSize.h * scale,
      boxW: visW0 * scale,
      boxH: visH0 * scale
    };
  }, [naturalSize, availWidth, isSideways]);

  // ----- Xoay -----
  const rotateClockwise = useCallback(() => setRotation(r => (r + 90) % 360), []);
  const rotateAnticlockwise = useCallback(() => setRotation(r => (r - 90) % 360), []);

  // ----- Chuyển ảnh (thao tác tay thì dừng slideshow) -----
  const goToImage = useCallback((idx: number) => {
    setIsPlaying(false);
    setActiveIndex(idx);
  }, []);

  const goPrev = useCallback(() => {
    setIsPlaying(false);
    setActiveIndex(prev => (prev - 1 + images.length) % images.length);
  }, [images.length]);

  const goNext = useCallback(() => {
    setIsPlaying(false);
    setActiveIndex(prev => (prev + 1) % images.length);
  }, [images.length]);

  // Đổi ảnh đang xem -> reset góc xoay + tạo lại Image() offscreen (dùng crossOrigin để canvas export
  // không bị lỗi tainted) trỏ đúng ảnh mới, phục vụ nút tải về.
  useEffect(() => {
    if (!activeImage?.url) return;
    setRotation(0);
    setNaturalSize(null);
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous'); // tránh lỗi CORS khi vẽ canvas
    img.src = `${activeImage.url}?crossorigin`; // thêm query để trình duyệt không dùng bản cache không có CORS
    imageRef.current = img;

    return () => {
      imageRef.current = null;
    };
  }, [activeImage?.url]);

  // Slideshow tự chuyển ảnh — chỉ chạy khi có nhiều hơn 1 ảnh, dừng ngay khi tắt/đóng modal
  useEffect(() => {
    if (!isPlaying || !hasMultiple) return;
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % images.length);
    }, SLIDESHOW_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [isPlaying, hasMultiple, images.length]);

  // ----- Tải 1 ảnh đang xem (vẽ vào canvas rồi lưu png) -----
  const handleDownloadImage = async () => {
    const img = imageRef.current;
    if (!img?.width) {
      message.error(tv('ErrorSaveImg'));
      return;
    }

    setIsSaving(true);
    try {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d')?.drawImage(img, 0, 0);

      const a = document.createElement('a');
      a.download = activeImage?.name || `aom1_download_${nowStamp()}.png`;
      a.href = canvas.toDataURL('image/png');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.log('err load img', error);
      message.error(tv('ErrorSaveImg'));
    } finally {
      setIsSaving(false);
    }
  };

  // ----- Tải toàn bộ ảnh -> gộp thành 1 file .zip -----
  // (thay vì tải rời từng file, dễ bị trình duyệt chặn tải hàng loạt và lộn xộn thư mục tải về)
  const handleDownloadAll = async () => {
    if (images.length === 0) return;
    setIsSavingAll(true);
    let hasError = false;
    try {
      const zip = new JSZip();
      const usedNames = new Set<string>();
      let addedCount = 0;

      for (let i = 0; i < images.length; i++) {
        const img = images[i];
        try {
          const res = await fetch(`${img.url}?crossorigin`, { method: 'GET' });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const blob = await res.blob();
          zip.file(getUniqueFileName(img.name || `anh_${i + 1}.png`, i, usedNames), blob);
          addedCount++;
        } catch (err) {
          hasError = true;
          console.log('Lỗi tải 1 file trong danh sách tải tất cả:', img.url, err);
        }
      }

      if (addedCount > 0) {
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        saveAs(zipBlob, `anh_${nowStamp()}.zip`);
      }
      if (hasError) message.error(tv('ErrorSaveAllImg'));
    } catch (error) {
      message.error(tv('ErrorSaveAllImg'));
    } finally {
      setIsSavingAll(false);
    }
  };

  return (
    <ModalComponent
      modalTitle={t('Administrator.UploadImage.Title')}
      modalSize="medium"
      visible={props.isOpen}
      hiddenFooter
      onCancel={props.callBackClose}
      className="z-50"
    >
      <div className="px-4 pb-2 flex flex-col gap-2">
        {/* Khung ảnh chính — nền tối, mũi tên chuyển ảnh 2 bên, toolbar icon đè góc dưới trái, số
            thứ tự đè góc dưới phải (giống UI thư viện ảnh camera xe) */}
        <div
          ref={setViewerNode}
          className="relative bg-black rounded-md overflow-hidden"
          style={{ height: VIEWER_HEIGHT }}
        >
          {activeImage && (
            // limitToBounds={false}: ảnh xoay bằng CSS nên kích thước layout không đổi, nếu giữ giới hạn mặc định
            // thì ảnh xoay dọc (cao hơn khung) sẽ không kéo lên xuống được. Nút Reset đưa ảnh về giữa khung.
            <TransformWrapper key={activeImage.url} wheel={{ smoothStep: 0.003 }} limitToBounds={false} centerOnInit>
              <TransformComponent
                wrapperStyle={{ width: '100%', height: '100%' }}
                contentStyle={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div
                  className="relative flex-none"
                  style={fitted ? { width: fitted.boxW, height: fitted.boxH } : undefined}
                >
                  <img
                    id="view-one-image"
                    src={activeImage.url}
                    alt=""
                    onLoad={e => setNaturalSize({ w: e.currentTarget.naturalWidth, h: e.currentTarget.naturalHeight })}
                    style={
                      fitted
                        ? {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            width: fitted.imgW,
                            height: fitted.imgH,
                            maxWidth: 'none',
                            transform: `translate(-50%, -50%) rotate(${rotation}deg)`
                          }
                        : // Chưa biết kích thước gốc (đang tải): hiển thị tạm theo giới hạn thường
                          { maxWidth: availWidth || '100%', maxHeight: IMAGE_MAX_HEIGHT }
                    }
                  />
                </div>
              </TransformComponent>
              <ViewerControls
                tv={tv}
                hasMultiple={hasMultiple}
                isPlaying={isPlaying}
                onTogglePlay={() => setIsPlaying(p => !p)}
                onRotateLeft={rotateAnticlockwise}
                onRotateRight={rotateClockwise}
                onDownload={handleDownloadImage}
              />
            </TransformWrapper>
          )}

          {hasMultiple && (
            <>
              <OverlayButton className="absolute left-2 top-1/2 -translate-y-1/2 z-10" onClick={goPrev}>
                <LeftOutlined />
              </OverlayButton>
              <OverlayButton className="absolute right-2 top-1/2 -translate-y-1/2 z-10" onClick={goNext}>
                <RightOutlined />
              </OverlayButton>
              <div className="absolute right-2 bottom-2 z-10 bg-black/45 text-white text-xs px-2 py-1 rounded-full">
                {activeIndex + 1}/{images.length}
              </div>
            </>
          )}
        </div>

        {/* Dải thumbnail bên dưới — bấm để chuyển nhanh, ảnh đang xem viền xanh */}
        {hasMultiple && (
          <div className="flex gap-2 overflow-x-auto pb-1">
            {images.map((img, idx) => (
              <button
                key={img.url + idx}
                type="button"
                onClick={() => goToImage(idx)}
                className={`shrink-0 w-[104px] rounded-md border-2 overflow-hidden text-left transition-colors ${
                  idx === activeIndex ? 'border-blue-500' : 'border-transparent hover:border-blue-300'
                }`}
              >
                <img src={img.url} alt="" className="w-full h-[68px] object-cover bg-gray-100" />
                <div className="px-1 py-0.5 bg-white text-[11px] text-gray-600 truncate">
                  {img.name || `#${idx + 1}`}
                </div>
              </button>
            ))}
          </div>
        )}

        <div className="flex space-x-2 justify-end">
          <div className="select-none rounded px-1 hover:bg-gray-500 bg-gray-400">
            <a className="text-white" href={activeImage?.url} target="_blank" rel="noreferrer">
              {tv('OpenInNewTab')}
            </a>
          </div>
          {hasMultiple && (
            <div className="select-none px-1 rounded hover:bg-green-600 bg-green-500">
              <button className="text-white" disabled={isSavingAll} onClick={handleDownloadAll}>
                {isSavingAll ? tv('Saveing') : tv('DownloadAll')}
              </button>
            </div>
          )}
          <div className="select-none px-1 rounded hover:bg-blue-500 bg-blue-400">
            <button className="text-white" disabled={isSaving} onClick={handleDownloadImage}>
              {isSaving ? tv('Saveing') : tv('SaveToDevice')}
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
}
